<template>
  <div class="mb-6">
    <div id="print" class="A4 landscape">
      <div class="sheet padding-10mm">
        <div class="columns">
          <div class="column">
            <h6 class="title is-6 is-pulled-left">TaskNo.{{ tasks_data.task.id }}</h6>
          </div>
        </div>
        <!-- タスク内容 -->
        <div class="columns">
          <div class="column">
            <h5 class="title is-5 is-pulled-left">{{ tasks_data.task.task_title }}</h5>
          </div>
          <div class="column">
            <h6 class="title is-6 is-pulled-right">登録日時:{{ tasks_data.task.created_at }}</h6>
          </div>
        </div>
        <!-- タスク内容詳細 -->
        <div class="columns">
          <div class="column is-12">
            <div class="box">
              <!-- コメント -->
              <div class="columns has-text-left">
                <div class="column">
                  <pre class="code_break">{{ tasks_data.task.comment }}</pre>
                </div>
              </div>
              <!-- 登録者・担当者 -->
              <div class="columns">
                <div class="column">
                  <p class="is-pulled-left">登録者：{{ tasks_data.task.register_name }}</p>
                  <hr />
                </div>
                <div class="column">
                  <p class="is-pulled-left">担当者：{{ tasks_data.task.rep_name }}</p>
                  <hr />
                </div>
              </div>
              <!-- 緊急性・ステータス -->
              <div class="columns">
                <div class="column">
                  <p class="is-pulled-left">ステータス：{{ tasks_data.task.status_name }}</p>
                  <hr />
                </div>
                <div class="column">
                  <p class="is-pulled-left">緊急性：{{ tasks_data.task.urgency_name }}</p>
                  <hr />
                </div>
              </div>
              <!-- 種別（通常・災害） -->
              <div class="columns">
                <div class="column">
                  <p
                    class="is-pulled-left"
                    v-if="modules.module_mode"
                  >種別：{{ tasks_data.task.mode_name }}</p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="column">
            <div id="map"></div>
          </div>-->
        </div>
        <!-- タスクログ表示 -->
        <!-- <span class="is-pulled-left">履歴({{ tasks_data.logs.task_log.length }}件)</span> -->
        <h6>変更履歴（降順）</h6>
        <div class="box">
          <div class="content" v-for="rireki in tasks_data.task_log" v-bind:key="rireki.id">
            <div class="notification has-background-white" v-if="rireki.select == false">
              <button class="delete" @click="rireki.select = true"></button>
              <div class="has-background-white has-text-left">
                <p>
                  <strong>{{ rireki.register }}</strong>
                  <span class="has-text-grey">/ {{ rireki.created_at }}</span>
                </p>
                <p style="white-space: pre-line;" v-text="rireki.comment"></p>
              </div>
              <hr />
            </div>
          </div>
        </div>
        <!-- 画像一覧 -->
        <h6 class="title is-6" style="page-break-before: always;">添付画像</h6>
        <div class="columns" v-for="set in photo" v-bind:key="set.id">
          <div class="colunm" v-for="item in set" v-bind:key="item.id">
            <div class="box">
              <img :src="item.path" alt />
            </div>
          </div>
        </div>
        <h6 class="title is-6" style="page-break-before: always;">発見場所</h6>
        <div id="map" style="height: 90%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { T_STD, T_PALE, O_STD, BASEGIS } from "../../util.js";
import { mapState } from "vuex";

export default {
  data: function () {
    return {
      map: null,
      Map_BaseLayer: {
        "地理院地図 標準": T_STD,
        "地理院地図 淡色": T_PALE,
        "地理院地図 航空写真": BASEGIS,
        "OpenStreetMap 標準": O_STD,
      },
    };
  },
  props: {
    tasks_data: () => ({
      task: {},
      task_log: {},
    }),
    photo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      modules: (state) => state.auth.modules,
    }),
  },
  methods: {
    //マップの作成
    initMap() {
      if (this.map !== null) return;
      this.map = L.map("map", {
        center: L.latLng(this.tasks_data.task.lat, this.tasks_data.task.lon),
        zoom: 16,
        layers: [
          new L.tileLayer(
            "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
            {
              attribution:
                "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>",
            }
          ),
        ],
      });
      let marker = L.marker(
        L.latLng(this.tasks_data.task.lat, this.tasks_data.task.lon),
        {
          icon: L.icon({
            iconUrl: "static/nanikamitsuketa_mitsuketazou.gif",
            iconSize: [48, 48],
          }),
          draggable: false,
        }
      );
      this.map.addLayer(marker);
      L.control
        .layers(this.Map_BaseLayer, null, {
          collapsed: true,
        })
        .addTo(this.map);
    },
  },
};
</script>

<style scoped>
/* paper.css */
/*https://github.com/cognitom/paper-css*/

/* @page { margin: 0 } */
#print {
  margin: 0;
  font-family: "IPAexGothic", sans-serif;
}
.sheet {
  margin: 0;
  /* overflow: hidden; */
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}

/** Paper sizes **/
#print.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
#print.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
#print.A4 .sheet {
  width: 209mm;
  height: 296mm;
}
#print.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
#print.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
#print.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}
#print.letter .sheet {
  width: 216mm;
  height: 279mm;
}
#print.letter.landscape .sheet {
  width: 280mm;
  height: 215mm;
}
#print.legal .sheet {
  width: 216mm;
  height: 356mm;
}
#print.legal.landscape .sheet {
  width: 357mm;
  height: 215mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm 20mm 10mm 0mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}

/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    height: 100%;
    width: 100% !important;
  }
  .sheet {
    background: #ffffff;
    /* margin: 5mm auto; */
    /* padding: 5mm 0; */
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  #print.A3.landscape {
    width: 420mm;
  }
  #print.A3,
  #print.A4.landscape {
    width: 297mm;
  }
  #print.A4,
  #print.A5.landscape {
    width: 209mm;
  }
  #print.A5 {
    width: 148mm;
  }
  #print.letter,
  #print.legal {
    width: 216mm;
  }
  #print.letter.landscape {
    width: 280mm;
  }
  #print.legal.landscape {
    width: 357mm;
  }
}
#map {
  width: 100%;
  height: 240px;
}
hr {
  margin: 1.5em 1.8em 0 0;
  border-top: 2px solid #bbb;
  border-bottom: 1px solid #fff;
}
.code_break {
  padding: 0.5em 0.2em;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: auto;
}

.sf-site-all {
  min-height: 90vh; /* 全体の高さを最低でもビューポートの100%にする ※メニューバーあるので高さの調整が必要*/
  display: flex; /* 子クラスを横並びにする */
  flex-direction: column; /* 子クラスの横並びの方向を縦にする */
  margin-top: 10px;
}
.sf-site-content {
  flex: 1; /* flexに1つだけ数値を指定するとその要素は伸びる */
}
/* NavbarとBottomにはflexを指定しないので伸びない */
/* 結果としてページファイルの中味だけが伸びて、ビューポート100%を実現 */
/* Bottomは下に貼り付く。スティッキーフッターを実現 */

.is-m-3 {
  margin: 0.2em;
}
.is-mr-3 {
  margin-right: 0.5em;
}
.footer {
  padding: 0.75em;
  border-radius: 10px;
  margin-bottom: 10px;
  background-color: rgb(201, 201, 201);
  border: 1px solid rgb(165, 165, 165);
}
.table-bg-gray {
  background-color: rgb(201, 201, 201);
}
.textarea {
  width: 100%;
  height: 10px;
  resize: none;
  overflow: auto;
}
</style>
